const CommonFriendStructure = {
    accUserId: "",
    friendList: [
        {
            friendid: "", // Unique Reel ID
            friendProfpic: "",
            createdOn: "",
            location: "",
            dateofbirth: "", 
            activelevel: "",
            gender: "",
        }
    ]
};

export default CommonFriendStructure;
